import { useAtom } from 'jotai'

import { roomTableStore, SelectedCellType } from 'src/stores'

export const useRoomTableStore = () => {
  const [roomTableStoreValue, setRoomTableStoreValue] = useAtom(roomTableStore.state)

  const toggleSelectedRoomId = (roomId: string) => {
    setRoomTableStoreValue(previous => {
      if (!previous.selectedRoomIds) {
        return {
          ...previous,
          selectedRoomIds: [roomId],
        }
      }

      const selectedRoomIds = previous.selectedRoomIds.includes(roomId)
        ? previous.selectedRoomIds.filter(id => id !== roomId)
        : [...previous.selectedRoomIds, roomId]

      return { ...previous, selectedRoomIds }
    })
  }

  const resetSelectedRoomIds = () => {
    setRoomTableStoreValue(previous => ({
      ...previous,
      selectedRoomIds: undefined,
    }))
  }

  const setSelectedRoomIds = (roomIds: string[]) => {
    setRoomTableStoreValue(previous => ({
      ...previous,
      selectedRoomIds: roomIds,
    }))
  }

  const updateShowAllRoomColumns = (isNewValue: boolean) => {
    setRoomTableStoreValue(previous => ({
      ...previous,
      isShowAllRoomColumns: isNewValue,
    }))
  }

  const updateShowAllSelectMasterColumns = (isNewValue: boolean) => {
    setRoomTableStoreValue(previous => ({
      ...previous,
      isShowAllSelectMasterColumns: isNewValue,
    }))
  }

  const updateShowAllConstructorColumns = (isNewValue: boolean) => {
    setRoomTableStoreValue(previous => ({
      ...previous,
      isShowAllConstructorColumns: isNewValue,
    }))
  }

  const updateSelectedCell = (newValue: SelectedCellType) => {
    setRoomTableStoreValue(previous => ({
      ...previous,
      selectedCell: newValue,
    }))
  }

  const resetSelectedCell = () => {
    setRoomTableStoreValue(previous => ({
      ...previous,
      selectedCell: undefined,
    }))
  }

  return {
    roomTableStoreValue,
    toggleSelectedRoomId,
    resetSelectedRoomIds,
    setSelectedRoomIds,

    updateShowAllRoomColumns,
    updateShowAllSelectMasterColumns,
    updateShowAllConstructorColumns,

    updateSelectedCell,
    resetSelectedCell,
  }
}
